import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { request } from "../../../utils/api";
import { ToastContainer } from "react-toastify";
import Loading from "../utilComponent/Loading";
import NotFoundTitle from "../utilComponent/NotFoundTitle";
import Pagination from "../utilComponent/Pagination";
import DateRangeFilter from "../utilComponent/DateRangeFilter";

const ViewInvoice = () => {
  const navigation = useNavigate();
  const [loading, setLoading] = useState(false);
  const [calculation, setCalculation] = useState([]);
  const [date, setDate] = useState();
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const [pagination, setPagination] = useState({
    current_page: 1,
    per_page: 15,
    total: 0,
    last_page: 1,
  });

  const getCalculation = async (page = 1) => {
    try {
      setLoading(true);
      const params = new URLSearchParams();
      params.append("page", page);
      params.append("per_page", pagination.per_page);

      if (date) {
        params.append("from_date", date);
        params.append("to_date", date);
      } else if (fromDate && toDate) {
        params.append("from_date", fromDate);
        params.append("to_date", toDate);
      } else if (fromDate) {
        params.append("from_date", fromDate);
      } else if (toDate) {
        params.append("to_date", toDate);
      }

      const response = await request({
        url: `invoice-cards?${params.toString()}`,
        method: "GET",
      });

      if (response.status && response.data) {
        const items = Object.values(response.data);
        setCalculation(items);
        setPagination(response.data.pagination || pagination);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getCalculation(pagination.current_page);
  }, [fromDate, toDate, pagination.current_page]);

  const handlePageChange = (page) => {
    setPagination({ ...pagination, current_page: page });
    getCalculation(page);
  };

  const handleDateRangeChange = ({ fromDate, toDate }) => {
    setDate("");
    setFromDate(fromDate);
    setToDate(toDate);
    setPagination((p) => ({ ...p, current_page: 1 }));
  };

  const redirectUserInvoice = (item) => {
    navigation(`/calculation-list/${item.user_id}`);
  };

  const countDateKeys = (obj) => {
  if (!obj || typeof obj !== "object") return 0;

  return Object.keys(obj).filter((key) =>
    /^\d{4}-\d{2}-\d{2}$/.test(key)
  ).length;
};


  return (
    <>
      <ToastContainer />
      <div className="container-fluid p-0">
        <div className="page-toolbar px-xl-4 px-sm-2 px-0 py-3">
          <div className="container-fluid">
            <div className="row g-3 mb-3 align-items-center">
              <div className="col">
                <ol className="breadcrumb bg-transparent mb-0">
                  <li className="breadcrumb-item">
                    <Link className="text-secondary" to="/hrms">
                      Home
                    </Link>
                  </li>
                  <li className="breadcrumb-item">
                    <span className="text-secondary">Calculation</span>
                  </li>
                  <li className="breadcrumb-item active">View Calculation</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <div className="card mx-4">
          <div className="row px-4 my-3 g-3">
            <DateRangeFilter onChange={handleDateRangeChange} />
          </div>

          {/* <div className="row px-4 my-3 g-3">
            <div className="col-md-4">
              <label className="form-label fw-bold">Date</label>
              <input
                type="date"
                className="form-control"
                value={date}
                onChange={(e) => handleSingleDate(e.target.value)}
              />
            </div>

            <div className="col-md-4">
              <label className="form-label fw-bold">From Date</label>
              <input
                type="date"
                className="form-control"
                value={fromDate}
                onChange={(e) => handleFromDate(e.target.value)}
              />
            </div>

            <div className="col-md-4">
              <label className="form-label fw-bold">To Date</label>
              <input
                type="date"
                className="form-control"
                value={toDate}
                onChange={(e) => handleToDate(e.target.value)}
              />
            </div>
          </div> */}
          <hr
            style={{
              border: 0,
              borderTop: "2px dotted gray",
              margin: "10px 0",
            }}
          />
          <div className="row g-3 px-4 mt-2">
            {loading ? (
              <div className="col-12 text-center py-5">
                <Loading />
              </div>
            ) : calculation.length === 0 ? (
              <div className="col-12 text-center py-5">
                <NotFoundTitle title="No calculation data found" />
              </div>
            ) : (
              calculation.map((p) => (
                <div className="col-3" key={p.id}>
                  <div
                    className="card mb-3"
                    style={{
                      width: "100%",
                      border: "1px solid #ccc",
                    }}
                  >
                    <div className="card-body">
                      <p className="card-text mb-1">
                         <strong>Labels:</strong> {countDateKeys(p)}
                      </p>
                      <p className="card-text mb-1">
                        <strong>User name:</strong> {p?.user_name || 'N/A'}
                      </p>
                      <p className="card-text mb-1">
                        <strong>User email:</strong> {p.user_email}
                      </p>
                      <div className="d-grid gap-2">
                        <button
                          className="btn btn-success"
                          onClick={() => redirectUserInvoice(p)}
                        >
                          Detail
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            )}
            <Pagination
              currentPage={pagination.current_page}
              lastPage={pagination.last_page}
              onPageChange={handlePageChange}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewInvoice;
